import Footer from "../../components/Footer/Footer.js";
import Navbar from "../../components/Menu/Menu.js";
import "./FaleConosco.css"

function FaleConosco() {
  return (
    <div>
      <Navbar />
      <div className="BannerFaleConosco">
        <div className="formContato">
          <div className="formularioCard">
            <h1>Fale <br /><strong>Conosco</strong></h1>
            <select placeholder="Selecione um assunto">
              <option>Selecione um assunto</option>
              <option>Reclamação</option>
              <option>Elogio</option>
              <option>Sugestão</option>
              <option>Dúvida</option>
              <option>Reclamação</option>
              <option>Representação</option>
              <option>Outro</option>
            </select>
            <select placeholder="Selecione um Setor">
              <option>Selecione um Setor</option>
              <option>Sac</option>
              <option>RH</option>
              <option>Marketing</option>
              <option>Financeiro</option>
              <option>Vendas</option>
              <option>Faturamento e Logística</option>
              <option>Compras</option>
              <option>Respresentantes</option>
              <option>Outros</option>
            </select>
            <textarea type="text" placeholder="mensagem" />
            <button type="submit">Enviar</button>
          </div>
        </div>
        <div className="atendente">
          <img src="../../../assets/atendente.png" alt="mulher telemarketing" />
        </div>
      </div>
      <div className="sectionContatoVendas">
        <div className="cardContato">
          <h3>
            ESCRITÓRIO DE VENDAS
            SÃO PAULO - SP
          </h3>
          <div class="telefone">
            <i><span class="material-symbols-outlined">
              call
            </span></i>
            <p>(11) 5642-3700</p>
          </div>
          <div class="adress">
            <i>
              <span class="material-symbols-outlined">
                mail
              </span>
            </i>
            <p>vendas@canoinhas.com.br</p>
          </div>
        </div>

        <div className="cardContato">
          <h3>
            ESCRITÓRIO DE VENDAS
            CURITIBA/PR
          </h3>
          <div class="telefone">
            <i><span class="material-symbols-outlined">
              call
            </span></i>
            <p>(41) 3402-1733</p>
          </div>
          <div class="adress">
            <i>
              <span class="material-symbols-outlined">
                mail
              </span>
            </i>
            <p>comercial.cwb@canoinhas.com.br</p>
          </div>
        </div>
      </div>
      <div className="ciaFabrica">
        <iframe title="mapa" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14321.560407545787!2d-50.3571881!3d-26.1839854!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3f47e088edce358e!2sCia%20Canoinhas%20de%20Papel!5e0!3m2!1spt-BR!2sbr!4v1674803618854!5m2!1spt-BR!2sbr" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <div className="bottomCiaFabrica">
          <h3>
            Fábrica Canoinhas - SC
          </h3>
          <div class="telefone">
            <i><span class="material-symbols-outlined">
              call
            </span></i>
            <p>(47) 3621 7000</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default FaleConosco;